import React from "react";
import styles from "./UiPrimitives.module.css";

const UiStickyScoreCard = ({
  topOffset = 96,
  maxWidth = 240,
  compact = false,
  sticky = true,
  title,
  score,
  total,
  className,
  style,
  children,
}) => {
  const inlineStyle = {
    "--ui-sticky-top": `${topOffset}px`,
    "--ui-sticky-max-width": `${maxWidth}px`,
    ...style,
  };

  const classNames = [
    styles.stickyScoreCard,
    compact ? styles.stickyScoreCardCompact : "",
    sticky ? "" : styles.stickyScoreCardStatic,
    className || "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classNames} style={inlineStyle}>
      {children ? (
        children
      ) : (
        <>
          {title && <div className={styles.stickyScoreTitle}>{title}</div>}
          <div className={styles.stickyScoreNumbers}>
            <div className={styles.stickyScoreValue}>{score}</div>
            <div className={styles.stickyScoreDivider} />
            <div className={styles.stickyScoreTotal}>{total}</div>
          </div>
        </>
      )}
    </div>
  );
};

export default UiStickyScoreCard;
